<template>
    <form id="BrandSelectForm" :action="route" method="POST" ref="form">
        <input type="hidden" name="_token" :value="csrf">
        <b-form-select id="BrandSelect" class="custom-select-toolbar"
                name="brand"
                v-model="value"
                size="sm"
                @change="onChange">
            <option v-for="option in options" :key="option.id" :value="option.id" :selected="option.selected" :disabled="option.disabled">{{ option.value }}</option>
        </b-form-select>
    </form>
</template>

<script>
    export default {
        props: {
            route: {
                required: true,
                type: String,
            },
            options: {
                required: true,
                type: [Object, Array],
            },
            storedData: {
                type: [String, Number],
                default: 0,
            },
        },

        data() {
            return {
                value: this.storedData,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },

        mounted() {
        },

        methods: {
            onChange: function () {
                this.$refs.form.submit();
            },
        },
    }
</script>
